import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorI18nService extends MatPaginatorIntl {
  itemsPerPageLabel = 'Eléments par page';
  nextPageLabel = 'Page Suivante';
  previousPageLabel = 'Page Précedente';
  getRangeLabel = (page: number, pageSize: number, length: number): string =>
    `${page + 1} - ${length} sur ${pageSize}`;
}
